import uuidV4 from 'lib/string/uuidV4Utils'
import { FetchReviewsOkResponse } from 'api/review'

export function userReviewsMap(response: FetchReviewsOkResponse): App.ReviewsFetch {
  const { result, total } = response

  // We need to ensure all reviews have an ID for use on the CP as unique key
  return {
    total,
    reviews: result.map<App.Review>(review => ({
      id: review.id || uuidV4(),
      rating: review.rating,
      review: review.review,
      improvementSuggestion: review.improvementSuggestion,
      companionship: review.companionship,
      definition: review.definition,
      staffRating: review.staffRating,
      facilitiesRating: review.facilitiesRating,
      valueRating: review.valueRating,
      locationRating: review.locationRating,
      accommodationRating: review.accommodationRating,
      nps: review.nps,
      howImprove: review.howImprove,
      bestCompanyAreas: review.bestCompanyAreas,
      userId: review.userId,
      orderId: review.orderId,
      offerId: review.offerId,
      propertyId: review.propertyId,
      experienceId: review.experienceId,
      tourId: review.tourId,
      userName: review.userName,
      userCountry: review.userCountry,
      source: review.source,
      tourBrand: review.tourBrand,
      isPubliclyVisible: review.isPubliclyVisible,
      offerPackageName: review.offerPackageName,
      offerRoomName: review.offerRoomName,
      orderNumberOfNights: review.orderNumberOfNights,
      reservationCheckinDate: review.reservationCheckinDate,
      createdAt: review.createdAt,
      updatedAt: review.updatedAt,
      userOrdersCount: review.userOrdersCount,
      userReviewsCount: review.userReviewsCount,
      photos: review.photos,
      response: review.response,
    })),
  }
}
